import state from './modulePackageManagementState.js'
import mutations from './modulePackageManagementMutations.js'
import actions from './modulePackageManagementActions.js'
import getters from './modulePackageManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

